const styles = (theme) => ({
  divider: {
    backgroundColor: theme.palette.neutral.lighter,
  },
});

export default styles;
